// extracted by mini-css-extract-plugin
export var fileExt = "_v0-8";
export var fileIcon = "_v0-6";
export var fileLink = "_v0-5";
export var fileName = "_v0-7";
export var image = "_v0-1";
export var imageError = "_v0-3";
export var imageErrorIcon = "_v0-4";
export var imageLink = "_v0-0";
export var imageLoaded = "_v0-2";